var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('article',{class:{ mobile: _vm.isMobile },attrs:{"id":"app-vue","dir":"ltr"}},[_c(_vm.isMobile ? 'slot-reachme-entry' : 'slot-reachme-icon',{tag:"component",attrs:{"state":_vm.state}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }